var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 51,
    viewBox: "0 0 46 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2104 51.0003H4.40619C3.40997 51.0003 2.60303 50.1834 2.60303 49.1971V35.27C2.60303 34.2737 3.41993 33.4668 4.40619 33.4668H11.2104C12.2066 33.4668 13.0135 34.2837 13.0135 35.27V49.1971C13.0235 50.1934 12.2066 51.0003 11.2104 51.0003Z",
    fill: "#8799C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.064 51.0002H19.9073C18.7417 51.0002 17.7754 50.0438 17.7754 48.8683V28.7745C17.7754 27.6089 18.7318 26.6426 19.9073 26.6426H26.064C27.2295 26.6426 28.1959 27.599 28.1959 28.7745V48.8683C28.1959 50.0438 27.2395 51.0002 26.064 51.0002Z",
    fill: "#8799C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9676 50.9995H35.3589C34.0339 50.9995 32.958 49.9136 32.958 48.5986V22.3482C32.958 21.0232 34.0439 19.9473 35.3589 19.9473H40.9676C42.2926 19.9473 43.3685 21.0331 43.3685 22.3482V48.5986C43.3685 49.9236 42.2926 50.9995 40.9676 50.9995Z",
    fill: "#8799C5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8244 0.00338292C39.6327 0.0930429 37.9292 1.94602 38.0188 4.14767L27.8972 14.0999L19.2699 6.54856L3.4798 22.3885C1.44751 22.6475 -0.0767107 24.4009 0.00298713 26.483C0.0926471 28.6747 1.95558 30.3782 4.14727 30.2885C6.33896 30.1989 8.0425 28.3359 7.95284 26.1443C7.94288 25.9649 7.90303 25.7956 7.87314 25.6163L19.7581 14.2095L28.0965 21.5118L41.9141 7.94327C41.9938 7.94327 42.0734 7.9632 42.1531 7.95324C44.3448 7.86358 46.0484 6.00064 45.9587 3.80895C45.8691 1.61726 44.0161 -0.0862771 41.8244 0.00338292Z",
    fill: "#8799C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph1);
export default __webpack_public_path__ + "static/media/Graph1.de64a9f5bbcf5b25fb958db7e4022149.svg";
export { ForwardRef as ReactComponent };